<!--Copyright (c) Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information.-->

<p class="documentation-header">Field Types</p>
<p class="documentation-sub-header">LfFieldInfo Interface</p>
<ul>
  <li>id: number</li>
  <li>name: string</li>
  <li>displayName: string</li>
  <li>description?: string</li>
  <li>fieldType?: FieldType</li>
  <li>length?: number</li>
  <li>defaultValue?: string</li>
  <li>isMultiValue?: boolean</li>
  <li>isRequired?: boolean</li>
  <li>constraint?: string</li>
  <li>constraintError?: string</li>
  <li>listValues?: Array&lt;string&gt;</li>
  <li>format?: FieldFormat</li>
  <li>currency?: string</li>
  <li>formatPattern?: string</li>
</ul>
<p class="documentation-sub-header">FieldType Enum</p>
<ul>
  <li>DateTime</li>
  <li>String</li>
  <li>Date</li>
  <li>ShortInteger</li>
  <li>LongInteger</li>
  <li>List</li>
  <li>Number</li>
  <li>Time</li>
  <li>Blob (NOT IMPLEMENTED)</li>
</ul>
<p class="documentation-sub-header">FieldFormat Enum</p>
<ul>
  <li>None</li>
  <li>ShortDate (NOT IMPLEMENTED)</li>
  <li>LongDate (NOT IMPLEMENTED)</li>
  <li>ShortDateTime (NOT IMPLEMENTED)</li>
  <li>LongDateTime (NOT IMPLEMENTED)</li>
  <li>ShortTime (NOT IMPLEMENTED)</li>
  <li>LongTime (NOT IMPLEMENTED)</li>
  <li>GeneralNumber</li>
  <li>Currency</li>
  <li>Percent</li>
  <li>Scientific (NOT IMPLEMENTED)</li>
  <li>Custom (NOT IMPLEMENTED)</li>
</ul>
<p class="documentation-sub-header">FieldValue Interface</p>
<ul>
  <li>fieldId: number</li>
  <li>fieldName?: string</li>
  <li>values?: Array&lt;&#123; [key: string]: string; &#125;&gt;</li>
  <li>fieldType?: FieldType</li>
  <li>groupId?: number</li>
  <li>flags?: number</li>
</ul>
<p class="documentation-sub-header">type LfFieldValue = string;</p>
<p class="documentation-sub-header">FieldValues Interface</p>
<ul>
  <li>[fieldId: number]: FieldValue</li>
</ul>

<p class="documentation-header">Template Specific Types</p>
<p class="documentation-sub-header">TemplateInfo Interface</p>
<ul>
  <li>id: number</li>
  <li>name: string</li>
  <li>displayName: string</li>
  <li>description?: string</li>
  <li>fieldCount?: number</li>
  <li>color?: LfColor</li>
</ul>
<p class="documentation-sub-header">TemplateValue Interface</p>
<ul>
  <li>id: number</li>
  <li>name: string</li>
  <li>fieldValues: &#123; [key: string]: FieldValue &#125;</li>
</ul>

<p class="documentation-sub-header">LfColor Interface</p>
<ul>
  <li>a: number</li>
  <li>r: number</li>
  <li>b: number</li>
  <li>g: number</li>
</ul>
<p class="documentation-sub-header">TemplateFieldInfo Interface extends LfFieldInfo</p>
<ul>
  <li>all properties of LfFieldInfo</li>
  <li>rule?: Rule</li>
  <li>groupId?: number</li>
  <li>groupName?: string</li>
</ul>

<p class="documentation-sub-header">Rule Interface</p>
<ul>
  <li>ancestors: number[]</li>
</ul>
